/* 
*
*
Edge Creative Social Share JS File 
*
*
*/


/* 
Collapseable Share Button Animation
*/


(function($) {

	var $socialBtn = $("#js-c-social-share");
	  
	  $socialBtn.on("click", function(e) {
	  $(".c-social-share-icons").toggleClass("is-active");
	});

})(jQuery);